import { Component, OnInit, ViewChild } from '@angular/core';
import { DatePipe, formatDate } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { CustomerService } from '../_services/customer.service';
import { DebtorService } from '../_services/debtor.service';
import { MatSort, MatPaginator, MatTableDataSource } from '@angular/material';
import { AppConfig, ExcelService } from '../_helpers/index';
import { ParameterData } from '../_helpers/index';
import { Router } from '@angular/router';
import { DataService } from '../_helpers/dataservice.service'
import { PaymentProcessService } from '../_services';
import { PaymentProcess } from '../_models';
import { PaymentCreation, PaymentStatus } from '../_enums/payment';
import { AuthService } from '../_services/auth.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';


@Component({
  selector: 'paymentlist',
  templateUrl: './paymentlist.component.html',
  styleUrls: ['../../assets/css/customer-list-table.css']
})

export class PaymentListComponent implements OnInit {

  public customer_public_id: string;
  public user_public_id: string;
  excelExportData: any;

  ddlCustomerAccount: any[];
  ddlPaymentCreation: any[];
  ddlPaymentStatus: any[];
  ddlCustomerAccounts: any[];

  searchFilterForm: FormGroup;
  searchRangoFilterForm: FormGroup;
  displayedColumns: string[] = ['created', 'description', 'client', 'total', 'method', 'reference', 'status', 'actions'];
  dataSourcePaymentsList = new MatTableDataSource();
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  filterValue;
  isRangoVisiable = false;
  auth0Profile: any;
  isLoading = true;
  pageSize: number;
  PageSizeOptions: number[];
  offsetTimeZone: any;
  offsetMinutes: any;
  offsetTimeVal: any;
  isadmin = false;

  isRangoStatus = "None";
  isExportExcelAvailable = true;
  isCreateAvailable = true;
  constructor
    (
      private customerService: CustomerService, private formBuilder: FormBuilder
      , private _fb: FormBuilder
      , private excelService: ExcelService, private parameterData: ParameterData
      , private router: Router, private debtorService: DebtorService
      , private dataService: DataService, private paymentProcessService: PaymentProcessService
      , private paymentCreation: PaymentCreation, private paymentStatus: PaymentStatus
      , private datePipe: DatePipe
      , private auth: AuthService
      , private spinnerService: Ng4LoadingSpinnerService

    ) {
    this.spinnerService.show();

    this.pageSize = AppConfig.settings.gridPageSetting.PageSize;
    this.PageSizeOptions = AppConfig.settings.gridPageSetting.PageSizeOptions;

    this.isRangoVisiable = false;
    this.ddlPaymentCreation = paymentCreation._creation;
    this.ddlPaymentStatus = paymentStatus._status;

    this.isadmin = false;
  }




  ngOnInit() {
    this.checkThisPageGrants();
    var browserStorage;
    let browserStorage1 = (localStorage.getItem('isCorporate') == 'undefined') ? null : localStorage;

    let browserStorageAdmin = localStorage.getItem('isadmin');
    if (browserStorage1 == null) {
      browserStorage = localStorage.getItem('companyId');
      if (browserStorage == null || browserStorage == '' || browserStorage == undefined) {
        this.router.navigate(['/home']);
      }
      else {
        this.customer_public_id = localStorage.getItem('companyId');
        this.user_public_id = localStorage.getItem('userId');
      }

      if (browserStorageAdmin == 'true') {

        this.isadmin = true;
      }
      else {

        this.isadmin = false;
      }
    }
    else {
      this.customer_public_id = localStorage.getItem('subcompanyId');
      this.user_public_id = localStorage.getItem('userId');
    }

    browserStorage = (typeof localStorage === 'undefined') ? null : localStorage;
    this.offsetTimeZone = (typeof browserStorage.getItem('timezone') === 'undefined') ? null : browserStorage.getItem('timezone');

    if (this.offsetTimeZone == null || this.offsetTimeZone === 'undefined' || Number.isNaN(this.offsetTimeZone)) {
      this.offsetTimeZone = -5.00;
      this.offsetMinutes = 0;
      this.offsetTimeVal = (this.offsetTimeZone * 3600000);
      AppConfig.settings.userSetting.defaultTimeZone = this.offsetTimeVal;
    }
    else {
      this.offsetTimeZone = browserStorage.getItem('timezone');
      this.offsetMinutes = 30;
      this.offsetTimeVal = (this.offsetTimeZone * 3600000);
      AppConfig.settings.userSetting.defaultTimeZone = this.offsetTimeVal;
    }

    this.getCustomerAccountList();

    this.searchFilterForm = this.formBuilder.group({
      searchText: ['', Validators.required]
    });

    this.searchRangoFilterForm = this._fb.group({
      searchFromDate: [''],
      searchToDate: ['']
    });

    if (this.paymentCreation._creation.length > 8) {
      this.paymentCreation._creation.shift();
    }

    this.paginator._intl.itemsPerPageLabel = "Registros por página";
    this.paginator._intl.nextPageLabel = "siguiente página";
    this.paginator._intl.lastPageLabel = "última página";
    this.paginator._intl.previousPageLabel = "anterior página";
    this.paginator._intl.firstPageLabel = "primera página";

    this.getCustomerPaymentsList();
    this.dataSourcePaymentsList.paginator = this.paginator;
    this.dataSourcePaymentsList.sort = this.sort;
  }//end

  applyFilter() {

    this.filterValue = this.searchFilterForm.controls.searchText.value;
    this.filterValue = this.filterValue.trim();
    this.filterValue = this.filterValue.toLowerCase();
    this.dataSourcePaymentsList.filter = this.filterValue;
  }//end

  getCustomerPaymentsList() {
    this.paymentProcessService.getPaymentProcessList(this.customer_public_id).subscribe(data => {
      let resourcesReturn = data["data"];
      this.isLoading = false;
      this.dataSourcePaymentsList.data = resourcesReturn;
      this.excelExportData = resourcesReturn;

      this.spinnerService.hide();
    },
      error => {
        this.isLoading = false;
        console.log('Failed while trying to the Search All Result. ' + error);
      });
  }//end

  getCustomerAccountList() {
    this.customerService.getCustomerAccountList(this.customer_public_id).subscribe(data => {
      let resourcesReturn = data;
      this.ddlCustomerAccount = resourcesReturn;
      this.ddlCustomerAccount = this.ddlCustomerAccount.filter(t => t.type !== 'COLLECT' && t.type !== 'RECEIVABLE');
    },
      error => {
        console.log('Failed while trying to the Search All Result. ' + error);
      });
  }//end

  filterCreationDetails(creation) {

    var currentDate = new Date();

    var currentweekFirstDate = new Date();
    var currentweekLastDate = new Date();

    var lastweekFirstDate = new Date();
    var lastweekLastDate = new Date();

    currentweekFirstDate.setDate(currentweekFirstDate.getDate() - currentweekFirstDate.getDay());
    currentweekLastDate.setDate(currentweekFirstDate.getDate() + 7);

    var currentmonthFirstDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    var currentmonthLastDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);

    var lastmonthFirstDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1);
    var lastmonthLastDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0);

    lastweekFirstDate.setDate(lastweekFirstDate.getDate() - 7);
    lastweekLastDate.setDate(lastweekFirstDate.getDate() + 6);



    // All Datas Condition
    if (creation == 0) {
      this.dataSourcePaymentsList.filter = '';
    }

    // Current Month Filter Condition
    if (creation == 1) {
      this.dataSourcePaymentsList.filter = '';
      let CurrentmonthFirstDate = formatDate(currentmonthFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US');
      let CurrentmonthEndDate = formatDate(currentmonthLastDate, 'yyyy-MM-dd 23:59:00', 'en-US');
      this.dataSourcePaymentsList.filterPredicate = (data: PaymentProcess, filter: string) =>
        data.created >= CurrentmonthFirstDate && data.created <= CurrentmonthEndDate;

    }

    // Current Week Filter Condition
    if (creation == 2) {
      this.dataSourcePaymentsList.filter = '';
      var WeekstartDate1 = new Date(formatDate(currentweekFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US'));
      var WeekendDate1 = new Date(formatDate(currentweekLastDate, 'yyyy-MM-dd 23:59:00', 'en-US'));

      let WeekstartDate = this.convertGMTTime(WeekstartDate1);
      let WeekendDate = this.convertGMTTime(WeekendDate1);
      this.dataSourcePaymentsList.filterPredicate = (data: PaymentProcess, filter: string) =>
        data.created >= WeekstartDate && data.created <= WeekendDate;

    }

    // Today Filter Condition
    if (creation == 3) {
      this.dataSourcePaymentsList.filter = '';
      currentDate.setDate(currentDate.getDate());

      var todayStartDate = new Date(formatDate(currentDate, 'yyyy-MM-dd 00:00:00', 'en-US'));
      let startDate = this.convertGMTTime(todayStartDate);

      var todayEndDate = new Date(formatDate(currentDate, 'yyyy-MM-dd 23:59:00', 'en-US'));
      let endDate = this.convertGMTTime(todayEndDate);


      this.dataSourcePaymentsList.filterPredicate = (data: PaymentProcess, filter: string) =>
        data.created >= startDate && data.created <= endDate;
    }

    // Yesterday Filter Condition
    if (creation == 4) {
      this.dataSourcePaymentsList.filter = '';
      currentDate.setDate(currentDate.getDate() - 1);


      var yesterDayStartDate = new Date(formatDate(currentDate, 'yyyy-MM-dd 00:00:00', 'en-US'));
      let startDate = this.convertGMTTime(yesterDayStartDate);

      var yesterdayEndDate = new Date(formatDate(currentDate, 'yyyy-MM-dd 23:59:00', 'en-US'));
      let endDate = this.convertGMTTime(yesterdayEndDate);

      this.dataSourcePaymentsList.filterPredicate = (data: PaymentProcess, filter: string) =>
        data.created >= startDate && data.created <= endDate;
    }


    // Last Week Filter Condition
    if (creation == 5) {
      this.dataSourcePaymentsList.filter = '';

      let lastWeekstartDate = formatDate(lastweekFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US');
      let lastWeekendDate = formatDate(lastweekLastDate, 'yyyy-MM-dd 23:59:00', 'en-US');


      this.dataSourcePaymentsList.filterPredicate = (data: PaymentProcess, filter: string) =>
        data.created >= lastWeekstartDate && data.created <= lastWeekendDate;

    }

    // Last Month Filter Condition
    if (creation == 6) {
      this.dataSourcePaymentsList.filter = '';
      let LastmonthFirstDate = formatDate(lastmonthFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US');
      let LastmonthEndDate = formatDate(lastmonthLastDate, 'yyyy-MM-dd 23:59:00', 'en-US');
      this.dataSourcePaymentsList.filterPredicate = (data: PaymentProcess, filter: string) =>
        data.created >= LastmonthFirstDate && data.created <= LastmonthEndDate;

    }
    if (creation != 0) {
      this.dataSourcePaymentsList.filter = '2018-10-24 01:59:45';
    }


    // Range Filter Condition
    if (creation == 7) {
      this.isRangoStatus = "creation";
      this.isRangoVisiable = true;
    }
    else {
      this.isRangoStatus = "None";
      this.isRangoVisiable = false;
    }
  }//end


  /** This function is used to filter the payment list based on Status wise; 
 * it accepts the param select status value
 */
  filterStatusDetails(status) {

    if (status == this.ddlPaymentStatus[0].value) {
      this.dataSourcePaymentsList.filter = '';
    }
    else if (status == this.ddlPaymentStatus[1].value) {
      this.dataSourcePaymentsList.filter = '';

      this.dataSourcePaymentsList.filterPredicate = (data: PaymentProcess, filter: string) =>
        data.status.toLowerCase() == filter;

      this.filterValue = 'NEW';

      this.dataSourcePaymentsList.filter = this.filterValue.trim().toLowerCase();
    }
    else if (status == this.ddlPaymentStatus[2].value) {
      this.dataSourcePaymentsList.filterPredicate = (data: PaymentProcess, filter: string) =>
        data.status == 'CONFIRMED';

      this.dataSourcePaymentsList.filter = 'CONFIRMED';
    }
    else if (status == this.ddlPaymentStatus[3].value) {
      this.dataSourcePaymentsList.filterPredicate = (data: PaymentProcess, filter: string) =>
        data.status == 'CANCELLED';

      this.dataSourcePaymentsList.filter = 'CANCELLED';
    }



  }//end



  filterAccountDetails(account) {

    // All Datas Condition
    if (account == 0) {
      this.dataSourcePaymentsList.filter = '';
    }

    if (account != 0) {
      this.dataSourcePaymentsList.filterPredicate = (data: PaymentProcess, filter: string) =>
        data.psp_operation.psp_account.name == account;

      this.dataSourcePaymentsList.filter = account;
    }


  }//end



  filterAllDetails() {


    if (this.searchRangoFilterForm.controls.searchFromDate.value !== null && this.searchRangoFilterForm.controls.searchToDate.value !== null
      && this.searchRangoFilterForm.controls.searchFromDate.value !== '' && this.searchRangoFilterForm.controls.searchToDate.value !== ''
    ) {




      if (this.isRangoStatus == "creation") {
        this.filterRangoDetails();
      }
    }
    else {

      this.isRangoVisiable = false;

    }

  }


  filterRangoDetails() {

    if (this.paymentCreation._creation.length > 8) {
      this.paymentCreation._creation.shift();
    }

    if (this.searchRangoFilterForm.controls.searchFromDate.value != '' && this.searchRangoFilterForm.controls.searchToDate.value != '') {
      this.filterValue = this.datePipe.transform(this.searchRangoFilterForm.controls.searchFromDate.value, "dd/MM/yyyy") + '-' + this.datePipe.transform(this.searchRangoFilterForm.controls.searchToDate.value, "dd/MM/yyyy");

      this.ddlPaymentCreation.unshift({ value: 8, name: this.filterValue });

      this.isRangoVisiable = false;


      this.dataSourcePaymentsList.filter = '';
      let CurrentmonthFirstDate = formatDate(this.searchRangoFilterForm.controls.searchFromDate.value, 'yyyy-MM-dd 00:00:00', 'en-US');
      let CurrentmonthEndDate = formatDate(this.searchRangoFilterForm.controls.searchToDate.value, 'yyyy-MM-dd 23:59:00', 'en-US');
      this.dataSourcePaymentsList.filterPredicate = (data: PaymentProcess, filter: string) =>
        data.created >= CurrentmonthFirstDate && data.created <= CurrentmonthEndDate;

      this.dataSourcePaymentsList.filter = '2018-10-24 01:59:45';
    }

  }//end

  paymentgridActionClick(viewtype, publicid) {

    switch (viewtype) {
      case 'paymentview':
        this.router.navigate([`/payments/${publicid}/view`]);
        break;
      case 'paymentedit':
        this.router.navigate([`/payments/${publicid}/edit`]);
        break;



      default:
        this.router.navigate([`/payments/${publicid}/view`]);

    }//end switch

  }//end


  paymentCancelClick(publicid) {

    this.paymentProcessService.cancelPaymentProcess(publicid).subscribe(data => {

      this.getCustomerPaymentsList();

    },
      error => {
        this.isLoading = false;
        console.log('Failed while trying to the Cancel Status ' + error);
      });

  }



  exportAsXLSX() {
    this.setExportExcelFileData(this.excelExportData);
  }





  setExportExcelFileData(excelExportData) {


    var excelHeader = ["CREADO", "METODO", "CLIENTE", "DESCRIPCION", "REFERENCIA", "NOMBRE", "ESTADO", "TOTAL"]

    var arrFinalData = [];
    var object_temp = {};
    var k = 0;
    var columnsKeyNames = [];

    for (k = 0; k < excelExportData.length; k++) {
      var singleRec_temp = excelExportData[k];
      delete singleRec_temp['external_id'];
      delete singleRec_temp['id'];
      delete singleRec_temp['public_id'];


      columnsKeyNames = Object.keys(singleRec_temp);

      var created_temp;
      var psp_operation_temp;
      var debtor_temp;
      var description_temp;
      var reference_temp;
      var name_temp;
      var status_temp;
      var total_temp;


      object_temp = {};

      for (var i = 0; i < columnsKeyNames.length; i++) {
        if (columnsKeyNames[i] == "created") {

          var startDate1 = new Date(formatDate(singleRec_temp[columnsKeyNames[i]], 'yyyy-MM-dd hh:mm:ss', 'en-US'));
          let createdate = this.convertExcelGMTTime(startDate1);


          created_temp = createdate;

        }

        if (columnsKeyNames[i] == "psp_operation") {
          psp_operation_temp = singleRec_temp[columnsKeyNames[i]].psp_account.name;
        }

        if (columnsKeyNames[i] == "debtor") {
          debtor_temp = singleRec_temp[columnsKeyNames[i]].name;
        }

        if (columnsKeyNames[i] == "description") {
          description_temp = singleRec_temp[columnsKeyNames[i]];
        }

        if (columnsKeyNames[i] == "debtor") {
          debtor_temp = singleRec_temp[columnsKeyNames[i]].name;
        }

        if (columnsKeyNames[i] == "reference") {
          reference_temp = singleRec_temp[columnsKeyNames[i]];
        }

        if (columnsKeyNames[i] == "name") {
          name_temp = singleRec_temp[columnsKeyNames[i]];
        }

        if (columnsKeyNames[i] == "status") {
          status_temp = singleRec_temp[columnsKeyNames[i]];
        }

        if (columnsKeyNames[i] === "total") {
          total_temp = singleRec_temp[columnsKeyNames[i]].symbol + ' ' + singleRec_temp[columnsKeyNames[i]].value;
        }



      }//end for


      for (var j = 0; j <= excelHeader.length; j++) {
        if (excelHeader[j] == "CREADO") {
          object_temp[excelHeader[j]] = created_temp
        }

        if (excelHeader[j] == "METODO") {
          object_temp[excelHeader[j]] = psp_operation_temp;
        }

        if (excelHeader[j] == "CLIENTE") {
          object_temp[excelHeader[j]] = debtor_temp;
        }

        if (excelHeader[j] == "DESCRIPCION") {
          object_temp[excelHeader[j]] = description_temp;
        }

        if (excelHeader[j] == "REFERENCIA") {
          object_temp[excelHeader[j]] = reference_temp;
        }

        if (excelHeader[j] == "NOMBRE") {
          object_temp[excelHeader[j]] = name_temp;
        }

        if (excelHeader[j] == "ESTADO") {
          object_temp[excelHeader[j]] = status_temp;
        }


        if (excelHeader[j] == "TOTAL") {
          object_temp[excelHeader[j]] = total_temp;
        }


      }//end for

      arrFinalData.push(object_temp);
    }

    this.excelService.exportAsExcelFile(arrFinalData, 'PaymentList');


  }//end function




  convertGMTTime(startDate1) {
    if (this.offsetTimeZone > 0) {
      let date: any = new Date(startDate1);
      var dateTimeZoneDiff = new Date(date);
      dateTimeZoneDiff.setMilliseconds(Number(this.offsetTimeVal));
      let startDate = formatDate(dateTimeZoneDiff, 'yyyy-MM-dd HH:mm:ss', 'en-US');
      return startDate;
    }
    else {
      var startDate2 = new Date(startDate1.setHours(startDate1.getHours() - this.offsetTimeZone));
      var startDate3 = new Date(startDate2.setMinutes(startDate2.getMinutes() - this.offsetMinutes));
      let startDate = formatDate(startDate3, 'yyyy-MM-dd HH:mm:ss', 'en-US');
      return startDate;
    }
  }


  //Convert GMT Excel Export

  convertExcelGMTTime(startDate1) {
    let date: any = new Date(startDate1);
    var dateTimeZoneDiff = new Date(date);
    dateTimeZoneDiff.setMilliseconds(Number(this.offsetTimeVal));
    let startDate = formatDate(dateTimeZoneDiff, 'yyyy-MM-dd hh:mm:ss', 'en-US');
    return startDate;
  }

  async checkThisPageGrants() {
    await this.auth.isKashioGrantsAvailable();
    this.isExportExcelAvailable =  this.auth.checkGrants('PAYMENTS','EXPORT');
    this.isCreateAvailable = this.auth.checkGrants('PAYMENTS','CREATE');
 }


}//end class


